import { DataType } from '@mode-switch/express';
import { Attr } from '@mode-switch/model';
import { FlamingoTypes } from '@mode/shared/contract-common';

// This method will construct the appropriate calc object to be used in the saving and updating of a calc
// that does not have a formula that is compilable
export function getIncompleteCalc(name: string, formula: string, desc: string): FlamingoTypes.ModeCalc {
  return {
    name,
    formula: {
      source: formula,
      role: undefined,
      type: {
        name: DataType.Name.String, // This is being used with no particular reason other than it is a valid type
      },
    },
    role: Attr.Role.Measure, // Determine if there is a better default value
    desc: desc, // Determine if there is a better default value
    scale: Attr.Scale.Quantitative, // Determine if there is a better default value
    source: Attr.Source.Calc, // Determine if there is a better default value
    type: Attr.Type.Continuous, // Determine if there is a better default value
    defaults: {
      frame: undefined,
      aggregate: undefined,
    }, // Determine if there is a better default value,
    order: null,
  };
}
